<template>
  <b-container>
    <b-breadcrumb>
      <b-breadcrumb-item to="/admin">Admin</b-breadcrumb-item>
      <b-breadcrumb-item active>Educational Resources</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="d-flex justify-content-between">
      <h1>All Educational Resources</h1>
      <b-btn class="mb-3" variant="secondary" size="sm" to="/admin/resources/create">
        Create Resource
      </b-btn>
    </div>
    <educational-items-table :count="25" pagination />
  </b-container>
</template>

<script>
import EducationalItemsTable from '@/components/admin/EducationalItemsTable'
export default {
  name: 'EducationalResources',
  components: {
    EducationalItemsTable,
  },
}
</script>
